import { subscribeNativePushRemote, unsubscribeNativePushRemote } from './utils'

export class NotificationService {
  static startNotificationService = async (token: string) => {
    await subscribeNativePushRemote(token)
    console.info('Notification service started')
  }

  static endNotificationService = async () => {
    await unsubscribeNativePushRemote()
    console.info('Notification service ended')
  }
}
